import { includes, map } from 'ramda';
import React, { FC } from 'react';
import { UseFormGetValues, UseFormRegister, UseFormSetValue } from 'react-hook-form';

import BasicText from '@ui/atoms/BasicText';
import Button, { IButtonProps } from '@ui/atoms/Button';
import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';
import HeadingText from '@ui/atoms/HeadingText';

import RoundedCheckbox from '@ui/forms/RoundedCheckbox';

import fullWidth from '@ui/styled/FullWidth';

import { commonLabels } from '@utils/button';

import { ICancelationSurveyCommonProps } from '../types';

interface ISurveyViewProps
	extends Pick<ICancelationSurveyCommonProps, 'cancelationReasons' | 'pageContent'> {
	getValues: UseFormGetValues<
		Partial<{
			[x: string]: unknown;
		}>
	>;
	register: UseFormRegister<
		Partial<{
			[x: string]: unknown;
		}>
	>;
	setValue: UseFormSetValue<
		Partial<{
			[x: string]: unknown;
		}>
	>;
	setView: React.Dispatch<React.SetStateAction<'cancelation_survey' | 'additional_info'>>;
}

const FullWidthColumn = fullWidth<IFlexColumn>(FlexColumn);
const FullWidthButton = fullWidth<IButtonProps>(Button);

const SurveyView: FC<ISurveyViewProps> = ({
	cancelationReasons,
	getValues,
	pageContent,
	register,
	setValue,
	setView,
}) => {
	const { cancelationSurveyContent, pageHeader, pageInfo } = pageContent;

	const CancelationCheckboxes = () =>
		map((surveyReason: { key: string; value: string }) => {
			const hasCancelationReason = includes(surveyReason.key, cancelationReasons);
			const surveyValue = !!getValues(surveyReason.key ?? '');

			if (!hasCancelationReason) {
				return <></>;
			}

			return (
				<RoundedCheckbox
					{...register(surveyReason.key)}
					checked={!!surveyValue}
					onClick={() => setValue(surveyReason.key, !surveyValue)}
					key={surveyReason.key}
					label={surveyReason.value}
					labelPosition="left"
				/>
			);
		}, cancelationSurveyContent);

	return (
		<FullWidthColumn gap="lg">
			<FullWidthColumn gap="sm">
				<HeadingText>{pageHeader}</HeadingText>
				<BasicText>{pageInfo}</BasicText>
			</FullWidthColumn>
			<FullWidthColumn gap="sm">
				<CancelationCheckboxes />
			</FullWidthColumn>
			<FullWidthButton
				variant="secondary"
				label={commonLabels.continue}
				type="button"
				onClick={() => setView('additional_info')}
			/>
		</FullWidthColumn>
	);
};

export default SurveyView;
